import StaffingLevelsDashboard from './StaffingLevelsDashboard';

export default StaffingLevelsDashboard;
